import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Footer from '../Components/Footer';
import Auth from '../Function/Auth';
import Header from '../Components/Header';
import { toast, ToastContainer } from "react-toastify";
import TokenBalance from '../Components/tokenBalance';
import { QRCodeSVG } from "qrcode.react";


function MasterWallet() {
  const authToken = sessionStorage.getItem('authToken');
  const baseurl = process.env.REACT_APP_BASE_API_URL;
  const [tabelLoading, setTableLoading] = useState(false); 
  const [deposits, setDeposits] = useState([]); 
  const [walletAddress, setWalletAddrees] = useState("");
   const [network, setNetwork] = useState([]);


  const [error, setError] = useState("");



  useEffect(() => {
    
    fetchTicket(1);
  }, []);


  const fetchTicket = async (page) => {
    console.log('Token ', authToken);

    const searchData = { 
        network: 'BEP20'
      };


    try {
      const wallets = await fetch(`${baseurl}/client/masterWallet`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(searchData),
      });

      if (wallets.status === 429) {
        console.error("Rate limit exceeded. Please try again later.");
        return; // Stop further processing
      }

      const walletData = await wallets.json();
      console.log('Static data', walletData);

      if (walletData.status) {
        setWalletAddrees(walletData.wallet);
        setNetwork(walletData.assets);

        setTableLoading(true);
      } else {
        // Handle any error condition
        setTableLoading(true);
        setDeposits("");
      }
    } catch (error) {
      console.error('Fetch error:', error);
    }
  };

const getbalance = () =>{
  console.log('Balance data');
}
  


const copyToClipboard = () => {
  if (walletAddress) {
    navigator.clipboard.writeText(walletAddress)
      .then(() => {
        toast.success("Wallet address copied to clipboard!");
      })
      .catch((error) => {
        console.error("Failed to copy:", error);
      });
  }
};
 

const getSoon = () =>{
  toast.warning('Comming soon !')
}



  return (
    <>
    <Header>
     <Auth/>
        <div className="main-content app-content" >
          <div className="container-fluid">
            {/* Page Header */}
            <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
              <div>
                <h4 className="mb-0">Master Wallets!</h4>
                
              </div>
            </div>
            {/* End Page Header */}

            {/* row */}
            <div className="row">
            <div className="col-sm-12 col-lg-5 col-xl-4">
                <div className="card custom-card">
                <div className="main-content-contacts pt-0">
                    <div className="main-content-left main-content-left-contacts">
                    <ul  className="nav nav-pills nav-style-3 border-bottom px-3" role="tablist">
                        
                        <li className="nav-item" role="presentation">
                        <a  className="nav-link active" data-bs-toggle="tab" role="tab" aria-current="page" aria-selected="true">
                            Wallets
                        </a>
                        </li>
                    </ul>
                    <div className="tab-content">
                        <div className="tab-pane text-muted p-0 border-0 active show" id="contacts" role="tabpanel">
                        <div className="">
                            <div className="main-contact-item selected">
                            <div className="avatar online avatar-md avatar-rounded">
                                <img alt="avatar" src="assets/images/logo/binance.svg" />
                            </div>
                            <div className="main-contact-body">
                                <h6 className="fs-14">Binance</h6>
                                <span className="phone">BEP20 Wallet </span>
                            </div>
                                <a className="main-contact-star" href="javascript:void(0);">
                                   <i className="fe fe-star text-success me-1"/>
                                </a>
                            </div>
                            <div className="main-contact-item" onClick={getSoon}>
                            <div className="avatar online avatar-md avatar-rounded">
                                <img alt="avatar" src="assets/images/logo/ethereum-eth.svg" />
                            </div>
                            <div className="main-contact-body">
                                <h6 className="fs-14">Ethereum</h6>
                                <span>ERC20</span>
                            </div>
                            <a className="main-contact-star" href="javascript:void(0);">
                                <i className="fe fe-star me-1 text-danger" />
                            </a>
                            </div>
                        </div>
                        </div>
                        
                    </div>
                    </div>
                </div>
                </div>
            </div>
            <div className="col-sm-12 col-lg-7 col-xl-8">
                <div>
                <a className="main-header-arrow" href="" id="ChatBodyHide">
                    <i className="icon ion-md-arrow-back" />
                </a>
                <div className="main-content-body main-content-body-contacts card custom-card">
                    <div className="main-contact-info-header pt-3">
                        <div className="row">
                            <div className='="col-sm-12  col-xl-4 col-md-4'>
                            <QRCodeSVG value={walletAddress} size={200} />
                            </div>
                            <div className='="col-sm-12  col-xl-8 col-md-8'>
                                <span className="mt-5">Binance BEP20 Wallet Address</span>
                                <div className="mt-5">
                                    <h6>{walletAddress || 'Loading..'}  &nbsp;&nbsp;<a onClick={copyToClipboard} className="text-primary" href="javascript:void(0)"> <i className="fa fa-copy"></i></a></h6>
                                </div>
                            </div>

                    </div>
                    </div>
                    <div className="main-contact-info-body p-4">
                    <div className="tab-pane border-0 p-0" id="gallery">
                        <div className="row">
                            <div className="mt-3"><h5>Assets</h5> </div>    
                        <div className="table-responsive country-table">
                            <table className="table table-striped table-bordered mb-0 text-nowrap mt-3" >
                            <thead>
                                <tr>
                                <th className="wd-lg-25p">LOGO</th>
                                <th className="wd-lg-25p">BALANCE</th>
                                <th className="wd-lg-25p">Name</th>
                                <th className="wd-lg-25p">TICKER</th>
                                <th className="wd-lg-25p">NETWORK</th>
                                <th className="wd-lg-25p">Con Address</th>
                                
                                </tr>
                            </thead>
                            <tbody>
                               {network && network.length > 0 && network.map(networks => (
                                    <React.Fragment key={networks.id}>
                                      { networks.id && 
                                       <TokenBalance networks={networks} walletAddress={walletAddress}  />
                                      }
                                    </React.Fragment>
                                  ))}       
                            </tbody>
                            </table>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
                <div>
                </div>
            </div>
            </div>

            {/* /row */}

          </div>
        </div>


        <ToastContainer/>
        </Header>


      <Footer/>

    </>
  )
}

export default MasterWallet